<template>
  <div style="padding: 20px;" class="content">
    <el-form :label-position="labelPosition" label-width="180px" :model="formInfo" ref="formInfo" :rules="rules"
             style="text-align: left;"
             v-loading="loading"
             element-loading-text="The input data is being submitted, please wait……">
      <el-form-item prop="radio" label="1. Enter PDB ID or Upload file.pdb for your generation">
        <el-radio v-model="formInfo.radio" label="1">
          <el-input v-model="formInfo.PDBId" placeholder="PDBId" style="width: 500px;"></el-input>
        </el-radio>
        <br><br>
        <el-radio v-model="formInfo.radio" label="2">
          <div style="display: inline-block">
            <el-upload
                class="upload-demo"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                action=""
                :http-request="httpRequest"
                :before-remove="beforeRemove"
                :multiple="false"
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="formInfo.fileList">
              <el-button type="primary">Click to upload</el-button>
              <el-button round type="success" plain @click="show()">Show example.pdb</el-button>
            </el-upload>

          </div>
        </el-radio>

      </el-form-item>
      <el-form-item prop="num"
                    label="2. Enter the number of molecules you want to generate (optional, max=100)."
      >
        <el-input v-model.number="formInfo.num"></el-input>
      </el-form-item>

      <el-form-item prop="email"
                    label="3.Please leave your email address and we will send the generated results to your email.">
        <el-input v-model="formInfo.email"></el-input>
          <span style="font-size: 12px; color: #909399; line-height: 1.5; display: block; margin-top: 4px;">
          Your uploaded data are used only for this task and are not shared or used for any other purpose. They are temporarily stored on our private server for up to six months.
        </span>
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" @click="submitForm" >Submit</el-button>
      </el-form-item>
    </el-form>
<!--    <Success :uuid="sid"  hidden></Success>-->
  </div>
</template>

<script>
import Success from "../views/Success";
var sid =""
export default {
  name: 'StructureBasedForm',
  components:{Success},
  data() {
    return {
      dis:false,
      loading:false,
      sid:sid,
      labelPosition: 'top',
      rules: {

        email: [
          {message: 'Please input the email address.', trigger: 'blur'},
          {type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change']}
        ],
        num: [
          // {message: 'The number of molecules cannot be empty'},
          {type: 'number', min:0,max:100,message: 'The number of molecules should be numerical.Range: 0~100.'}
        ],
        radio: [
          {required: true, message: 'Please choose one of them.'}
        ]
      },
      formInfo: {
        radio: '1',
        PDBId: '1ywn',
        fileList: [],
        num: 20,
        email: ''
      }
    };
  },
  methods: {
    show(){
      window.open("2euf.pdb")
    },
    handleRemove(file, fileList) {
      this.formInfo.fileList.pop();
      console.log(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The current limit is 1 file selected`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Confirmed to remove ${file.name}?`);
    },
    httpRequest(param) {
      console.log(param);
      console.log(param.file.name);

      const fileName = param.file.name;
      const suffix = ".pdb";
      if (fileName.toLowerCase().endsWith(suffix.toLowerCase()))
      {
        this.formInfo.fileList.push(param.file);
      }
      else
      {

        this.formInfo.fileList.pop();
        // 弹出一个带有消息的警告框
        return this.$confirm(`Please upload a pdb type file.`);
      }
    },
    submitForm() {
      this.dis=true


      const formData = new FormData();
      if (this.formInfo.radio === '1') {
        // 选择PDBId
        if (this.formInfo.PDBId === '') {
          this.$alert('Please input PDBId.');
          this.loading=false
          return;
        }
        formData.append("PDBId", this.formInfo.PDBId);
        formData.append("file", new File([''],'nofile.txt'))
      } else {
        // 选择上传文件
        if (this.formInfo.fileList.length == 0) {
          this.$alert('Please upload the file.');
          this.loading=false
          return;
        }
        formData.append("file", this.formInfo.fileList[0], this.formInfo.fileList[0].name);
      }
      this.$refs['formInfo'].validate((valid) => {
        if (valid) {
          this.loading=true
          sid = require('uuid').v1()//生成uuid
          formData.append("uid", sid);
          console.log('submit');
          formData.append("num", this.formInfo.num);
          if(this.formInfo.email=='')
          {
            this.formInfo.email="2659381657@qq.com"
          }
          formData.append("email", this.formInfo.email);
          // TODO: change the url
          axios.post("/generation/structure", formData).then(res => {
            console.log(res.data);
            this.dis=false
            this.loading=false
            var that=this
            if (res.data.code === 403) {
              this.$alert(res.data.msg,"Tips",{
                confirmButtonText: 'Ok',
                callback:action => {
                  that.$router.push({
                    path:'/generation/success',
                    query:{
                      sid:sid
                    }
                  })
                }
              });
              return false;
            }
            else if (res.data.code === 402)//获取对应的PDB文件失败
            {
              this.$alert(res.data.msg,"Tips",{
                confirmButtonText: 'Ok',
                callback:action => {
                  this.$router.push('/generation/structure-based')
                }
              });
              return false;
            }
            else if(res.data.code === 401)
            {
              this.$alert(res.data.data,"Tips",{
                confirmButtonText: 'Ok',
                callback:action => {
                  location.reload()
                }
              });
              return false;
            }
            else
            {
              this.$router.push({
                path:'/generation/success',
                query:{
                  sid:sid
                }
              })
            }
          }).catch(err => {
            // console.log(err);
            this.loading=false
            this.$alert('error submit!!');
            return false;
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.submit {
  text-align: center !important;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}
</style>
